import React from 'react';
import { styled } from '@mui/system';
import { TextField, Typography, Select, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, FormGroup, Checkbox } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'white',
    justifyContent: 'center',

});
const UserDet = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    width: '80%',
    border: '2px solid #D8D0D0',
    borderRadius: '12px',
});
const GenerateButton = styled('button')({
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    marginTop: 10,
    cursor: 'pointer',
    fontSize: '16px',
    borderRadius: '10px',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)'
    },
});

const StudentDetails = ({ data, setData, industryChecked, handleIndustryChange, handleNextClick, validationError, name, setName }) => {

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleHometownChange = (event) => {
        setData((prevData) => ({ ...prevData, hometown: event.target.value }));
    };

    const handleExpChange = (event) => {
        setData((prevData) => ({ ...prevData, expyears: event.target.value }));
    };

    const handleEducationChange = (event) => {
        setData((prevData) => ({ ...prevData, education: event.target.value }));
    };

    const handleGenderChange = (event) => {
        setData((prevData) => ({ ...prevData, gender: event.target.value }));
    };

    const handleOtherIndustries = (event) => {
        setData((prevData) => ({ ...prevData, otherIndustries: event.target.value }));
    };

    const handleTargetJobRoleChange = (event) => {
        setData((prevData) => ({ ...prevData, targetJobRole: event.target.value }));
    };

    return (
        <MainContainer>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '81%' }}>
                <Typography color='black' style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '20px'
                }}>
                    About you
                </Typography>
            </div>
            <UserDet>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography color='black' align='left' style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>First Name<span style={{ color: 'red', marginLeft: '4px' }}>*
                            </span>
                        </Typography>
                        <TextField
                            name="name"
                            value={name}
                            onChange={handleNameChange}
                            fullWidth
                            InputProps={{
                                style: {
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    borderRadius: '12px'
                                },
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color='black' align='left'
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px'
                            }}>Location<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                        </Typography>
                        <Select
                            value={data.hometown}
                            onChange={handleHometownChange}
                            fullWidth
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            }}
                        >
                            <MenuItem value={"Tier 1 City/ Metropolitan Area"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                Tier 1 City/ Metropolitan Area
                            </Typography></MenuItem>
                            <MenuItem value={"Tier 2 City/Town"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                Tier 2 City/Town
                            </Typography></MenuItem>
                            <MenuItem value={"Tier 3 City/ Town"}><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                Tier 3 City/ Town
                            </Typography></MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color='black' align='left' style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Target Job Role<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                        </Typography>
                        <TextField
                            name="targetJobRole"
                            value={data.targetJobRole || ''}
                            onChange={handleTargetJobRoleChange}
                            fullWidth
                            InputProps={{
                                style: {
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    borderRadius: '12px'
                                },
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color='black' align='left' style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Years of Experience<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                        </Typography>
                        <Select
                            value={data.expyears}
                            onChange={handleExpChange}
                            fullWidth
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            }}
                        >
                            <MenuItem value={"< 1 years"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                &lt; 1 years
                            </Typography></MenuItem>
                            <MenuItem value={"1-3 years"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                1-3 years
                            </Typography></MenuItem>
                            <MenuItem value={"3– 5 Years"}><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                3– 5 Years
                            </Typography></MenuItem>
                            <MenuItem value={">5 years"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                &gt;5 years
                            </Typography></MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography color='black' align='left' style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px'
                        }}>Currently studying<span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                        </Typography>
                        <Select
                            value={data.education}
                            onChange={handleEducationChange}
                            fullWidth
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                borderRadius: '12px'
                            }}
                        >
                            <MenuItem value={"MBA Y1"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                MBA Y1
                            </Typography></MenuItem>
                            <MenuItem value={"MBA Y2"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                MBA Y2
                            </Typography></MenuItem>
                            <MenuItem value={"12th"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                12th
                            </Typography></MenuItem>
                            <MenuItem value={"BBA"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                BBA
                            </Typography></MenuItem>
                            <MenuItem value={"BCOM"}><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                BCOM
                            </Typography></MenuItem>
                            <MenuItem value={"B.E./ B.Tech"} ><Typography style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>
                                B.E./ B.Tech
                            </Typography></MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label" style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                color: 'black'
                            }}>Gender<span style={{ color: 'red', marginLeft: '4px' }}>*</span></FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={data.gender}
                                onChange={handleGenderChange}
                                style={{
                                    fontFamily: 'Poppins, sans-serif',
                                }}
                            >
                                <FormControlLabel value="female" control={<Radio />} label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Female
                                </Typography>} style={{ color: 'black', fontSize: '14px', fontWeight: 500 }} />
                                <FormControlLabel value="male" control={<Radio />} label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Male
                                </Typography>} style={{ color: 'black', fontSize: '14px', fontWeight: 500 }} />
                                <FormControlLabel value="other" control={<Radio />} label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Other
                                </Typography>} style={{ color: 'black', fontSize: '14px', fontWeight: 500 }} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <Typography color='black' align='left'
                            style={{
                                fontFamily: 'Poppins, sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                            }}>Industry(ies) of Previous Employment or Internship (If any)
                        </Typography>
                        <FormGroup row>
                            <FormControlLabel
                                control={<Checkbox
                                    checked={industryChecked.IT}
                                    onChange={handleIndustryChange}
                                    name="IT"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Information Technology
                                </Typography>} />
                            <FormControlLabel
                                control={<Checkbox checked={industryChecked.Finance}
                                    onChange={handleIndustryChange}
                                    name="Finance"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Finance and Banking
                                </Typography>}
                            />
                            <FormControlLabel
                                control={<Checkbox checked={industryChecked.Engineering}
                                    onChange={handleIndustryChange}
                                    name="Engineering"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Engineering and Manufacturing
                                </Typography>} />
                            <FormControlLabel
                                control={<Checkbox checked={industryChecked.Healthcare}
                                    onChange={handleIndustryChange}
                                    name="Healthcare"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Healthcare and Lifesciences
                                </Typography>}
                            />
                            <FormControlLabel
                                control={<Checkbox checked={industryChecked.Retail}
                                    onChange={handleIndustryChange}
                                    name="Retail"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Retail and E-Commerce
                                </Typography>}
                            />
                            <FormControlLabel
                                control={<Checkbox
                                    checked={industryChecked.Other}
                                    onChange={handleIndustryChange}
                                    name="Other"
                                    color="primary" />}
                                style={{
                                    color: 'black',
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}
                                label={<Typography style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                }}>
                                    Others
                                </Typography>}
                            />
                            <TextField
                                value={data.otherIndustries}
                                onChange={handleOtherIndustries}
                                InputProps={{
                                    style: {
                                        fonntFamily: 'Poppins, sans-serif',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        borderRadius: '12px'
                                    },
                                }}

                            />
                        </FormGroup>
                    </Grid>
                </Grid>
                {validationError && <p style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{validationError}</p>}
                <GenerateButton
                    onClick={handleNextClick}
                >
                    Next
                </GenerateButton>
            </UserDet>
        </MainContainer>
    );
}

export default StudentDetails;